module.exports = function() {
  return new Worker(__webpack_public_path__ + "0eeb426e7f89899fae88.worker.js");
};